import createActionConstants from 'lib/create-action-constants'

export const constants = createActionConstants('reset-password-modal', [
  'SET_RESET_PASSWORD_MODE',
  'SET_BEGIN_DESCRIPTION',
  'SET_RESET_PASSWORD_TOKEN',
  'SET_RESET_PASSWORD_FIELD',
  'SET_PASSWORD_POLICY',

  'RESET_PASSWORD_SUBMIT',
  'RESET_PASSWORD_SUBMIT_SUCCESS',
  'RESET_PASSWORD_SUBMIT_FAILURE',
  'RESET_PASSWORD_LINK_SENT',
  'RESET_PASSWORD_EXPIRED',
  'RESET_PASSWORD_LIMIT_EXCEEDED',
  'RESET_PASSWORD_INVALID_PASSWORD',

  'RESET_PASSWORD_MODAL_STATE'
])

export const setResetPasswordMode = mode => ({
  type: constants.SET_RESET_PASSWORD_MODE,
  payload: mode
})

export const setBeginDescription = beginDescription => ({
  type: constants.SET_BEGIN_DESCRIPTION,
  payload: beginDescription
})

export const setResetPasswordToken = resetPasswordToken => ({
  type: constants.SET_RESET_PASSWORD_TOKEN,
  payload: resetPasswordToken
})

export const resetPasswordModalState = () => ({
  type: constants.RESET_PASSWORD_MODAL_STATE
})

export const setResetPasswordField = (field, value, error) => ({
  type: constants.SET_RESET_PASSWORD_FIELD,
  payload: {
    field,
    value
  },
  error
})

export const setPasswordPolicy = passwordPolicy => ({
  type: constants.SET_PASSWORD_POLICY,
  payload: {
    ...passwordPolicy
  }
})

export const submit = (mode, fields) => ({
  type: constants.RESET_PASSWORD_SUBMIT,
  payload: {
    mode,
    fields
  }
})
